<template>
  <div class="project mt30">
    <!-- <div id="bd" style="display: show">
      <div class="yui-d0">
        <div class="dirlist">
          <div id="aspera_web_install" class="notinstalled" style="display: show">
            <strong id="install_message"></strong> <a id="manual_install_option" onclick="initAsperaConnect('manual')" href="javascript:void(0)"> </a>
          </div>
        </div>
      </div>
    </div> -->
    <el-row class="contable">
      <el-col :span="24">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span><i class="fa fa-gift fs14" /> Project Information</span>
          </div>
          <div>
            <el-form ref="form" :label-position="labelPosition" :model="form" label-width="200px">
              <el-form-item label="Project ID">
                <el-input v-model="projectid" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="ProteomeXchange ID">
                <label for="" class="lableline"><a :href="pxidlink+form.px_id" target="_blank">{{form.px_id}}</a></label>
              </el-form-item>
              <el-form-item label="Project Title">
                <el-input v-model="form.project_title" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="XML File">
                <label for="" class="lableline">
                  <a :href="xmllink+form.fileid" target="_blank" class="mr5">{{ form.filename }}</a>
                  <el-button type="primary" size="mini" icon="el-icon-download" @click="handleDownload(form.fileid)" round>Download</el-button>
                </label>
              </el-form-item>
              <el-form-item :label="'Download All Files ' +  form.subproject_size_sum ">
                <el-button type="primary" size="mini" icon="el-icon-download" data-download-file="true" data-direction="receive" :data-fasp-url="faspurl" :data-suggested-name="suggname" @click="handleAspera(projectid)" round>Aspera Download</el-button> *recommended
                <!-- <span data-download-file="true" data-direction="receive" :data-fasp-url="faspurl" :data-suggested-name="suggname">
                  Aspera Download
                </span>
                  <button
                  :data-download-file="true"
                  data-direction="receive"
                  alt="Download"
                  data-toggle="popover"
                  data-placement="top"
                  data-trigger="hover"
                  data-html="true"
                  data-fasp-url="faspe://guests@download.iprox.org.cn:33001/IPX0009168000?auth=yes&port=33001&bwcap=Unlimited&targetrate=45000&minrate=0&lockpolicy=no&locktargetrate=no&lockminrate=no&policy=fair&enc=none&protect=no&v=2&fallback=yes&httpport=8686"
                  data-suggested-name="IPX0009168000">
                      <span id="downByAspera">Aspera Download</span>
                      <i class="glyphicon glyphicon-download-alt"></i>
                  </button> -->

                <el-button type="primary" size="mini" icon="el-icon-download" @click="handleProflist(projectid)" round>Http Download</el-button>
              </el-form-item>
              <el-form-item label="Submission Type">
                <el-input v-model="form.submission_type" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Project Status">
                <el-input v-model="form.project_status" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Description">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" v-model="form.description" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Project Tag">
                <el-input v-model="form.project_tag" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Institution">
                <el-input v-model="form.institution" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Data Source" v-if="isshowall">
                <el-table
                  empty-text="No Data"
                  border
                  :data="datasourceData"
                  style="width: 100%">
                  <el-table-column
                    prop="dataset_id"
                    label="Dataset ID">
                  </el-table-column>
                  <el-table-column
                    prop="dataset_url"
                    label="Dataset URL">
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-form-item label="Submitter">
                <el-table
                  empty-text="No Data"
                  border
                  :data="submitterData"
                  style="width: 100%">
                  <el-table-column
                    prop="contact_name"
                    label="Contact Name"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="contact_email"
                    label="Contact Email"
                    width="220">
                  </el-table-column>
                  <el-table-column
                    prop="contact_affiliation"
                    label="Contact Affiliation">
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-form-item label="Lab Head">
                <el-table
                  empty-text="No Data"
                  border
                  :data="labheadData"
                  style="width: 100%">
                  <el-table-column
                    prop="contact_name"
                    label="Contact Name"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="contact_email"
                    label="Contact Email"
                    width="220">
                  </el-table-column>
                  <el-table-column
                    prop="contact_affiliation"
                    label="Contact Affiliation">
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-form-item label="Publication" v-if="isshowall">
                <el-table
                  empty-text="No Data"
                  border
                  :data="pubData"
                  style="width: 100%">
                  <el-table-column
                    prop="pubmed_id"
                    label="PubMed ID"
                    width="200">
                  </el-table-column>
                  <el-table-column
                    prop="reference"
                    label="Reference">
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-form-item label="Subproject Count">
                <el-input v-model="form.subproject_count" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Access Level">
                <el-input v-model="form.access_level" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Public Start Date">
                <el-input v-model="form.public_start_date" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Groups" v-if="isshowall && isShowNon1">
                <el-input v-model="showNon" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Groups" v-if="isshowall && !isShowNon1">
                <el-tag type="warning" v-for="(item, index) in formgroup" :key="index">{{item.group_name}}</el-tag>
              </el-form-item>
              <el-form-item label="Super Project" v-if="isshowall && isShowNon2">
                <el-input v-model="showNon" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="Super Project" v-if="isshowall && !isShowNon2">
                <el-tag type="warning" v-for="(item, index) in formsupro" :key="index">{{item.group_name}}</el-tag>
              </el-form-item>
              <el-form-item label="Grants" v-if="isshowall">
                <el-table
                  empty-text="No Data"
                  border
                  :data="grantsData"
                  style="width: 100%">
                  <el-table-column
                    prop="agency"
                    label="Agency"
                    width="230">
                  </el-table-column>
                  <el-table-column
                    prop="agency_abbr"
                    label="Agency Abbr."
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="grant_id"
                    label="Grant ID"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="grant_title"
                    label="Grant Title">
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-form-item label="">
                <el-checkbox v-model="ischecked" @change="handleShowAll">Show All Information</el-checkbox>
              </el-form-item>
              <el-divider></el-divider>
              <el-form-item label="Overall Rating">
                <el-rate
                  v-model="form.rating"
                  disabled
                  show-score
                  text-color="#ff9900"
                  score-template="{value}">
                </el-rate>
              </el-form-item>
              <el-form-item>
                <el-button class="commonbtn" type="primary" @click="onSubmit">View Comments</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
        <el-card class="box-card mt20" shadow="never">
          <div slot="header" class="clearfix">
            <span><i class="fa fa-cogs fs14" /> Show SubProject</span>
          </div>
          <div>
            Search: <el-input size="medium" v-model="searchkey" placeholder="" class="searchInput mr5" clearable></el-input>
            <el-button class="submitbtn" @click="handleSearchsubpro">Search</el-button>
            <el-table
              empty-text="No Data"
              :data="subproData"
              border
              style="width: 100%"
              v-loading="loading"
              @sort-change="handleSort"
              class="mt10">
              <el-table-column
                prop="subtitle_en"
                label="Subproject Title"
                :show-overflow-tooltip="isOverflow">
                <template slot-scope="scope">
                  <span class="tablelink" @click="handlesubProurl(scope.row.subproject_id)">{{scope.row.subtitle_en}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="subproject_id"
                label="Subproject ID"
                sortable
                :show-overflow-tooltip="isOverflow"
                width="138">
              </el-table-column>
              <el-table-column
                prop="px_id"
                label="PXID"
                sortable
                width="130"
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                prop="species"
                label="Species"
                width="154"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                prop="instrument"
                label="Instrument"
                width="154"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                prop="fileCount"
                label="File Count (size)"
                width="154"
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                prop="submit_time"
                label="Release Date"
                sortable
                width="150"
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next"
              :total="allNum"
              :page-size="pageSize"
              @current-change="handleChangepage"
              class="pagination mb10">
            </el-pagination>
          </div>
        </el-card>
        <el-card class="box-card mt20" shadow="never">
          <div slot="header" class="clearfix">
            <span><i class="fa fa-gift fs14" /> Evaluation (Please sign in for score and comments.)</span>
          </div>
          <div>
            <el-form ref="form" :label-position="labelPosition" :model="form" label-width="200px">
              <el-form-item label="Score">
                <el-row>
                  <el-col :span="4">
                    <el-rate
                      v-model="commen_rating"
                      disabled
                      show-score
                      text-color="#ff9900"
                      score-template="{value}">
                    </el-rate>
                  </el-col>
                  <el-col :span="12">
                    <el-button type="primary" size="mini" disabled>Not Rated</el-button>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="Comments">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" v-model="form.desc" :disabled="true"></el-input>
              </el-form-item>
              <el-divider></el-divider>
              <el-form-item>
                <el-button class="commonbtn floatRight" type="primary" @click="onSubmit">Submit</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
        <el-card class="box-card mt20" shadow="never">
          <div slot="header" class="clearfix">
            <span><i class="fa fa-cogs fs14" /> Show Log</span>
          </div>
          <div>
            <el-table
              empty-text="No Data"
              :data="logData"
              border
              style="width: 100%">
              <el-table-column
                prop="request_time"
                label="Request Time"
                width="180">
              </el-table-column>
              <el-table-column
                prop="operator"
                label="Operator"
                width="180">
              </el-table-column>
              <el-table-column
                prop="reason"
                label="Reason">
              </el-table-column>
              <el-table-column
                prop="agree_time"
                label="Agree Time">
              </el-table-column>
              <el-table-column
                prop="submit_time"
                label="Submit Time">
              </el-table-column>
              <el-table-column
                prop="operation_type"
                label="Operation Type">
              </el-table-column>
              <el-table-column
                prop="status"
                label="Status">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getProjectBasic, getProjectOptLog, getStatSubProjectList, getSearchSubProjectList, getProjectXmlDownload,
} from '@/api';

export default {
  name: 'project',
  data() {
    return {
      labelPosition: 'right',
      form: {
        name: '',
        region: '',
        project_title: '',
        submission_type: '',
        project_status: '',
        description: '',
        project_tag: '',
        institution: '',
        subproject_count: '',
        access_level: '',
        public_start_date: '',
        xmlfile: '',
        allfiles: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        rating: 3,
        filename: '',
        fileid: '',
      },
      showNon: 'none',
      isShowNon1: true,
      isShowNon2: true,
      submitterData: [],
      labheadData: [],
      pubData: [],
      grantsData: [],
      datasourceData: [],
      formgroup: [],
      formsupro: [],
      commen_rating: '',
      pxidlink: 'https://proteomecentral.proteomexchange.org/cgi/GetDataset?ID=',
      xmllink: 'https://www.iprox.cn/FAF016Controller/readXml.jsonp?fileId=',
      ischecked: false,
      ajax_data: {
        filters: [{
          item: 'projectid',
          equals: '',
        }],
      },
      projectid: 0,
      isshowall: false,
      ajax_data_log: {
        filters: [{
          item: 'projectid',
          equals: '',
        }],
      },
      logData: [],
      ajax_data_sublist: {
        search: {
          project_id: '',
          sub: '',
        },
        page: {
          startPage: 1,
          pageLength: 5,
        },
        order: {
          item: '',
          type: '',
        },
      },
      subproData: [],
      allNum: 0,
      pageSize: 5,
      searchkey: '',
      loading: true,
      isOverflow: true,
      orderConvert: {
        ascending: 'asc',
        descending: 'desc',
      },
      ajax_data_down: {
        search: {
          file_id: '',
        },
      },
      dowloadServerIp: 'download.iprox.org.cn',
      faspurl: '',
      suggname: '',
    };
  },
  mounted() {
    if (this.$route.query.id && this.$route.query.id != '') {
      this.projectid = this.$route.query.id;
      this.ajax_data.filters[0].equals = this.$route.query.id;
      getProjectBasic(this.ajax_data).then((res) => {
        const redata = res.result[0];
        redata.basic[0].subproject_size_sum = this.handleFilesize(redata.basic[0].subproject_size_sum);
        this.form = redata.basic[0];
        this.form.filename = redata.xml[0].file_name;
        this.form.fileid = redata.xml[0].file_id;
        this.submitterData = redata.contact_submitter;
        this.labheadData = redata.contact_Labhead;
        this.pubData = redata.publication;
        this.grantsData = redata.grant;
        this.datasourceData = redata.datasource;
        this.form.rating = redata.overallrate[0].point;
        this.formgroup = redata.group;
        this.formsupro = redata.super;
        if (redata.group.length != 0 && redata.group != '') {
          this.isShowNon1 = false;
        } else {
          this.isShowNon1 = true;
        }
      });
      this.ajax_data_log.filters[0].equals = this.$route.query.id;
      getProjectOptLog(this.ajax_data_log).then((res) => {
        this.logData = res.result;
      });
      this.ajax_data_sublist.search.project_id = this.$route.query.id;
      this.ajax_data_sublist.search.sub = this.searchkey;
      this.ajax_data_sublist.page.startPage = 1;
      getSearchSubProjectList(this.ajax_data_sublist).then((res) => {
        this.loading = false;
        const newData = res.result;
        newData.forEach((val, index) => {
          const fileCount = val.file_count;
          const fileSize = this.handleFilesize(val.file_size);
          val.fileCount = fileCount + fileSize;
        });
        this.subproData = newData;
        this.allNum = res.count;
      });
      // 赋值aspera
      const filePath = this.$route.query.id;
      const username = 'guests';// 正式时改为从cookie读取
      const password = 'guests';// 正式时改为从cookie读取
      const serverip = this.dowloadServerIp;
      const sshport = '33001';
      const asperauri = 'auth=yes&port=33001&bwcap=Unlimited&targetrate=45000&minrate=0&lockpolicy=no&locktargetrate=no&lockminrate=no&policy=fair&enc=none&protect=no&v=2';
      const data_fasp_url = `faspe://${username}@${serverip}:${sshport}/${filePath}?${asperauri}&fallback=yes&httpport=8686`;
      this.faspurl = data_fasp_url;
      this.suggname = filePath;

      // var filePath = this.$route.query.id;
      // var username = "guests";//正式时改为从cookie读取
      // var password = "guests";//正式时改为从cookie读取
      // var serverip = this.dowloadServerIp;
      // var sshport = "33001";
      // var asperauri = "auth=yes&port=33001&bwcap=Unlimited&targetrate=45000&minrate=0&lockpolicy=no&locktargetrate=no&lockminrate=no&policy=fair&enc=none&protect=no&v=2";
      // var data_fasp_url= "faspe://" + username + "@" + serverip + ":" + sshport + "/" + filePath + "?" + asperauri + "&fallback=yes&httpport=8686";
      // this.faspurl = data_fasp_url
      // this.suggname = filePath
    }
  },
  created() {

  },
  methods: {
    onSubmit() {},
    handleShowAll(param) {
      this.isshowall = param;
    },
    handleChangepage(val) {
      this.loading = true;
      this.ajax_data_sublist.page.startPage = val;
      getStatSubProjectList(this.ajax_data_sublist).then((res) => {
        this.loading = false;
        const newData = res.result;
        newData.forEach((val, index) => {
          const fileCount = val.file_count;
          const fileSize = this.handleFilesize(val.file_size);
          val.fileCount = fileCount + fileSize;
        });
        this.subproData = newData;
        this.allNum = res.count;
      });
    },
    handleSearchsubpro() {
      this.loading = true;
      this.ajax_data_sublist.search.project_id = this.$route.query.id;
      this.ajax_data_sublist.search.sub = this.searchkey;
      getSearchSubProjectList(this.ajax_data_sublist).then((res) => {
        this.loading = false;
        const newData = res.result;
        newData.forEach((val, index) => {
          const fileCount = val.file_count;
          const fileSize = this.handleFilesize(val.file_size);
          val.fileCount = fileCount + fileSize;
        });
        this.subproData = newData;
        this.allNum = res.count;
      });
    },
    handleSort(column, prop, order) {
      // console.log(column, prop, order)
      this.loading = true;
      this.ajax_data_sublist.order.item = column.prop;
      this.ajax_data_sublist.order.type = this.orderConvert[column.order];
      if (column.order !== null && column.prop !== null) {
        getSearchSubProjectList(this.ajax_data_sublist).then((res) => {
          this.loading = false;
          const newData = res.result;
          newData.forEach((val, index) => {
            const fileCount = val.file_count;
            const fileSize = this.handleFilesize(val.file_size);
            val.fileCount = fileCount + fileSize;
          });
          this.subproData = newData;
          this.allNum = res.count;
        });
      } else {
        this.loading2 = false;
      }
    },
    handlesubProurl(param) {
      const routerData = this.$router.resolve({ path: '/subproject', query: { id: param } });
      window.open(routerData.href, '_blank');
    },
    handleFilesize(param) {
      let fileSize = param;
      if (fileSize == 0 || fileSize == null) {
        fileSize = ` (${0}K)`;
      } else if (fileSize < 1024) {
        fileSize = ` (${fileSize.toFixed(2)}K)`;
      } else if (fileSize >= 1024 && fileSize < 1024 * 1024) {
        fileSize = ` (${(fileSize / 1024).toFixed(2)}M)`;
      } else {
        fileSize = ` (${
          (fileSize / 1024 / 1024).toFixed(2)
        }G)`;
      }
      return fileSize;
    },
    handleDownload(param) {
      this.ajax_data_down.search.file_id = param;
      getProjectXmlDownload(this.ajax_data_down).then((res) => {
        const fileData = res.result[0];
        window.open(fileData.url);
      });
    },
    handleProflist(param) {
      const routerData = this.$router.resolve({ path: '/profilelist', query: { id: param } });
      window.open(routerData.href, '_blank');
    },
    handleAspera(projectId) {
      // var filePath = projectId + "/" + subprojectId;
      // var username = "guests";//正式时改为从cookie读取
      // var password = "guests";//正式时改为从cookie读取
      // var serverip = this.dowloadServerIp;
      // var sshport = "33001";
      // var asperauri = "auth=yes&port=33001&bwcap=Unlimited&targetrate=45000&minrate=0&lockpolicy=no&locktargetrate=no&lockminrate=no&policy=fair&enc=none&protect=no&v=2";
      // var data_fasp_url= "faspe://" + username + "@" + serverip + ":" + sshport + "/" + filePath + "?" + asperauri + "&fallback=yes&httpport=8686";
      // jQuery("#asperaDownloadAllSub").attr("data-fasp-url",data_fasp_url);
      // jQuery("#asperaDownloadAllSub").attr("data-suggested-name",filePath);

      // _fileData = fileData;
      const filePath = projectId;
      const username = 'guests';// 正式时改为从cookie读取
      const password = 'guests';// 正式时改为从cookie读取
      const serverip = this.dowloadServerIp;
      const sshport = '33001';
      const asperauri = 'auth=yes&port=33001&bwcap=Unlimited&targetrate=45000&minrate=0&lockpolicy=no&locktargetrate=no&lockminrate=no&policy=fair&enc=none&protect=no&v=2';
      const data_fasp_url = `faspe://${username}@${serverip}:${sshport}/${filePath}?${asperauri}&fallback=yes&httpport=8686`;
      this.faspurl = data_fasp_url;
      this.suggname = filePath;
      // jQuery.ajax({
      //     type :'GET',
      //     url : jsonServer + "projectFileList/fileSizeCount.jsonp",
      //     data : {'projectId':projectId},
      //     dataType :'json',
      //     success : function (data) {
      //         console.log(data.fileSize)
      //         jQuery("#fileSizeCount").text(data.fileSize);
      //         jQuery("#asperaDownloadAll").attr("data-fasp-url",data_fasp_url);
      //         jQuery("#asperaDownloadAll").attr("data-suggested-name",filePath);

      //     }
      // });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .project {
  }
</style>
